import { SHOW_INSTAGRAM, SHOW_TIKTOK, SHOW_YOUTUBE } from '../config';

/** Comma-separated list for CTA copy, e.g. "Facebook and Instagram." */
export function formatSocialCtaDesc() {
  const labels = ['Facebook'];
  if (SHOW_INSTAGRAM) labels.push('Instagram');
  if (SHOW_YOUTUBE) labels.push('YouTube');
  if (SHOW_TIKTOK) labels.push('TikTok');
  if (labels.length === 1) return `${labels[0]}.`;
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}.`;
  return `${labels.slice(0, -1).join(', ')}, and ${labels[labels.length - 1]}.`;
}
